import { Ability, AbilityBuilder } from '@casl/ability';

export const ability = new Ability();

export default (action: any, subject: any): any => {
  return ability.can(action, subject);
};

export const defineRulesFor = (permissions: any): any => {
  const { can, rules } = new AbilityBuilder(Ability);
  // This logic depends on how the
  // server sends you the permissions array
  try {
    if (permissions?.length >= 1) {
      permissions?.forEach((perm: any) => {
        if (perm?.split) {
          const per = perm?.split('_');
          can(per[0], per[1]);
        }
      });
    }
  } catch (error) {
    console.log(error);
  }

  return rules;
};
